import { Map } from 'immutable';
import { SAVED_SEARCH } from '@constants/actions';

const initialState = Map({
  savedSearches: []
});

const SavedSearch = (state = initialState, action) => {
  const actionPayload = action.payload;
  switch (action.type) {
    case SAVED_SEARCH.POPULATE:
      return state.set('savedSearches', actionPayload.savedSearches);
    default:
      return state;
  }
};

export default SavedSearch;